<div id="grievances-ombudsperson" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Ombudsperson for Student Grievances</h2>
    <p class="inner-lead mt-3">
      In accordance with UGC regulations, Shah Satnam Ji Girls' College has appointed a dedicated Ombudsperson to ensure a fair and transparent grievance redressal process for all students.
    </p>

    <hr class="divider">

    <div class="card mt-4 shadow-sm border-0">
      <div class="card-body p-0">
        <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
          style="width: 100%; height: 800px; position: relative;" class="rounded">
        </pdf-viewer>
      </div>
    </div>

  </div>
</div>
